import { PageCondition } from "./conditions";

export enum Direction {
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD",
  CURRENT = "CURRENT",
}

export enum PageTypes {
  ACTION = "action",
  POOL = "pool",
}

export interface PageSet {
  id: string;
  description?: string;
  pages: (Page | SwitchCondition)[];
  context_type: string;
  conditions?: PageCondition[];
}

type InheritablePageParams = {
  actions?: Action[];

  props?: PropertyBag & {
    /**
     * Numeric index of the progress bar this component is part of, if displayed.
     *
     * - 1 | 2 | 3 -> Progress bar section
     * - false -> No progress bar
     */
    progressBar?: number | false;
  };
};

export type Page = {
  pathname?: string;
  conditions?: PageCondition[];
} & InheritablePageParams;

export type SwitchCondition = {
  switch: string;
  cases: {
    [key: string]: Page;
    default?: Page;
  };
  conditions?: PageCondition[];
} & InheritablePageParams;

export interface Action {
  type: string;
  params?: PropertyBag;
}
